import { render, staticRenderFns } from "./ModuleClass.vue?vue&type=template&id=2536cf72&scoped=true&"
import script from "./ModuleClass.vue?vue&type=script&lang=js&"
export * from "./ModuleClass.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClass.vue?vue&type=style&index=0&id=2536cf72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536cf72",
  null
  
)

component.options.__file = "ModuleClass.vue"
export default component.exports